import styled from "@emotion/styled";

export const ItemContainer = styled.div``;

export const Container = styled.div<{ $variant?: string }>`
  display: flex;
  flex-flow: column wrap;
  gap: 28px 35px;

  max-block-size: 500px;

  ${ItemContainer}:first-child {
    ${props => props.theme.breakpoints.up("mediumDesktop")} {
      block-size: 100%;
    }
  }

  ${props => props.theme.breakpoints.up("mediumDesktop")} {
    max-block-size: 420px;
  }

  ${props =>
    props.$variant !== undefined &&
    ["home", "home-swap"].includes(props.$variant) &&
    props.theme.breakpoints.up("largeDesktop")} {
    max-inline-size: 500px;
  }
`;
